import styled from 'styled-components';
import ButterContent from 'components/ButterContent';

export const StyledMilestoneContainer = styled.div<{
  $isOpen?: boolean;
}>`
  font-size: 13px;
  background: ${({ theme }) => theme.palette.white};
  padding: ${({ theme }) => theme.spacing.space_2};
  padding-bottom: ${({ theme }) => theme.spacing.space_2};
  color: ${({ theme }) => theme.palette.neutrals.sky};
  :hover {
    z-index: 1;
    background: none;
    box-shadow: 0 0 32px rgba(0, 0, 0, 0.09);
  }

  ${({ $isOpen }) =>
    $isOpen
      ? `
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.09);
  z-index: 1;
  background: white;
  `
      : ''}
`;

export const StyledMilestoneParagraph = styled.p<{
  $bold?: boolean;
  $fontSize?: string;
}>`
  margin: 0 0 4px 0;
  ${({ $bold }) => ($bold ? 'font-weight: bold;' : 'font-weight: 500;')}
  ${({ $fontSize }) =>
    $fontSize ? `font-size: ${$fontSize};` : 'font-size: 13px;'}
`;

export const StyledButterContent = styled(ButterContent)`
  padding-top: ${({ theme }) => theme.spacing.space_2};
`;

export const StyledInquiryCodesTag = styled.span`
  display: inline-block;
  width: fit-content;
  max-width: 100%;
  overflow-x: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  background: #f5f5f5;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  padding: 0 7px;
  margin: 0 8px 0 0;
  font-size: 12px;
  line-height: 20px;
`;
